import React, { Suspense, useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation, Outlet } from "react-router";
import Loader from "../components/Common/Loader";

const Router = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.search,
      title: location.pathname,
    });
  }, [location]);

  return (
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
  );
};

export default Router;
